import React from 'react';
import './CG.css';
import PageStatique from '../../composants/PageStatique/PageStatique';

// Le corps des CGV est servi depuis la base (slug conditions-generales), editable au BO,
// au lieu d'un contenu fige dans le composant. Le chrome de page (.cgv-page) est conserve
// pour la route /cgv et l'iframe scroll-to-accept de l'inscription.
const CG: React.FC = () => {
    return (
        <div className="cgv-page">
            <div className="cgv-custom-container">
                <PageStatique slug="conditions-generales" />
            </div>
        </div>
    );
};

export default CG;
